/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {completeCopyModal} from '../../common/util/complete-copy-modal';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {createResourceCopy} from '../../../components/util/create-resource-copy';
import {nextCopyTitle} from '../../../components/util/next-copy-title';
import {Uuid} from '../../../components/util/uuid';
import {preTeamSaveFix} from './team-commons';

import template from './team-copy-modal.component.html';
import {TeamResource} from '../../../components/api/resources/resource/team.resource';

export interface TeamCopyResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: false,
  selector: 'adn-team-copy-modal',
  template
})
export class TeamCopyModalComponent implements OnInit {
  model: any;

  readonly onCopied = new Subject<TeamCopyResult>();

  originalName = '';
  name = '';
  description = '';
  destination = true;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(TeamResource) private readonly Team: any
  ) {
  }

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.name = nextCopyTitle(this.model?.name || '');
    this.description = this.model?.description || '';
  }

  copy(): void {
    const copy = createResourceCopy(this.Team, this.model, {
      id: Uuid.generate(),
      name: this.name,
      description: this.description || null
    });
    preTeamSaveFix({model: copy});
    copy.$save().then((saved: any) => {
      completeCopyModal(this.bsModalRef, this.onCopied, {model: saved, destination: this.destination});
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
